import { connect } from 'react-redux';

import SubEntityLink from '../components/SubEntityLink';
import { defaultMapDispatchToProps } from '../utils/ConnectDefaults';


export default connect(
  null,
  defaultMapDispatchToProps
)(SubEntityLink);